import { ThunkType } from "../../../../core/store/reducers";
import getSecurityEpsTrendApi from "../api/getSecurityEpsTrend";
import { setDisplayedEpsTrend } from "../statisticsDataSlice";
import { EpsTrendItem } from "../types";

// Load funkcija (reset + fetch)
export const loadSecurityEpsTrend = (
	symbol: string
): ThunkType => async (dispatch, getStore) => {
	// reset prethodnih podataka
	dispatch(setDisplayedEpsTrend(undefined));

	console.log(symbol)
	const statistics = await dispatch(
		getSecurity_EpsTrend(symbol)
	);
	console.log(statistics)

	dispatch(setDisplayedEpsTrend(statistics));
};

export const getSecurity_EpsTrend = (
	symbol: string
): ThunkType<Promise<EpsTrendItem | undefined>> =>
	async (dispatch, getStore, _extra) => {

		const store = getStore();

		if (store.data.auth.current.status !== "successful") {
			return undefined;
		}

		const { userId } = store.data.auth.current.user;

		const response = await dispatch(
			getSecurityEpsTrendApi(userId, symbol, "eps_trend")
		);

		console.log(response)
		if (!response || !response.meta) {
			return undefined;
		}
		const latest = response?.eps_trend?.[0];

		return {
			symbol: response.meta.symbol,
			date: latest.date,
			period: latest.period,
			current_estimate: latest.current_estimate,
			"7_days_ago": latest["7_days_ago"],
			"30_days_ago": latest["30_days_ago"],
			"60_days_ago": latest["60_days_ago"],
			"90_days_ago": latest["90_days_ago"],
		};
	};